import { useEffect } from 'react'

interface SEOHeadProps {
  title?: string
  description?: string
  image?: string
  url?: string
  canonical?: string
}

const DEFAULT_SEO = {
  title: 'Günüm Var! - Güvenilir Altın Günü Platformu',
  description:
    'Güvenilirliğine göre sana uygun altın günlerine katıl, kendi grubunu kur ve birikim yap. Altın, Dolar ve Euro günü seçenekleriyle.',
  image: 'https://gunumvar.com.tr/img/og-default.png',
  url: 'https://app.gunumvar.com.tr',
}

/**
 * SPA için dinamik meta etiket yöneticisi.
 * document.title + description + OG etiketlerini günceller.
 * SSR olmadığı için react-helmet-async gereksiz — DOM API kullanılır.
 */
export function SEOHead({ title, description, image, url, canonical }: SEOHeadProps) {
  const siteTitle = title ? `${title} | Günüm Var!` : DEFAULT_SEO.title
  const siteDescription = description || DEFAULT_SEO.description
  const siteImage = image || DEFAULT_SEO.image
  const siteUrl = url || DEFAULT_SEO.url
  const siteCanonical = canonical || siteUrl

  useEffect(() => {
    // Title
    document.title = siteTitle

    // Meta etiketlerini güncelle veya oluştur
    setMeta('description', siteDescription)
    setMeta('og:title', siteTitle, 'property')
    setMeta('og:description', siteDescription, 'property')
    setMeta('og:url', siteUrl, 'property')
    setMeta('og:image', siteImage, 'property')
    setMeta('twitter:title', siteTitle)
    setMeta('twitter:description', siteDescription)

    // Canonical link
    let canonicalEl = document.querySelector<HTMLLinkElement>('link[rel="canonical"]')
    if (!canonicalEl) {
      canonicalEl = document.createElement('link')
      canonicalEl.setAttribute('rel', 'canonical')
      document.head.appendChild(canonicalEl)
    }
    canonicalEl.setAttribute('href', siteCanonical)

    return () => {
      // Cleanup: varsayılanlara geri dön
      document.title = DEFAULT_SEO.title
      setMeta('description', DEFAULT_SEO.description)
      setMeta('og:title', DEFAULT_SEO.title, 'property')
      setMeta('og:description', DEFAULT_SEO.description, 'property')
      setMeta('og:url', DEFAULT_SEO.url, 'property')
      setMeta('og:image', DEFAULT_SEO.image, 'property')
    }
  }, [siteTitle, siteDescription, siteImage, siteUrl, siteCanonical])

  return null
}

/** Meta etiketini güncelle veya oluştur */
function setMeta(name: string, content: string, attr: 'name' | 'property' = 'name') {
  let el = document.querySelector<HTMLMetaElement>(`meta[${attr}="${name}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, name)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

export default SEOHead
